import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const Users03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 12C11.9853 12 14 9.98528 14 7.5C14 5.01472 11.9853 3 9.5 3C7.01472 3 5 5.01472 5 7.5C5 9.98528 7.01472 12 9.5 12Z"
      className="fill-none stroke-current"
    />
    <path
      d="M9.5 15C6.66937 15 4.15354 16.5446 2.55923 18.9383C2.20996 19.4628 2.03533 19.725 2.05543 20.0599C2.07109 20.3207 2.24205 20.64 2.45044 20.7976C2.71808 21 3.08617 21 3.82236 21H15.1776C15.9138 21 16.2819 21 16.5496 20.7976C16.758 20.64 16.9289 20.3207 16.9446 20.0599C16.9647 19.725 16.79 19.4628 16.4408 18.9383C14.8465 16.5446 12.3306 15 9.5 15Z"
      className="fill-none stroke-current"
    />
    <path
      d="M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7957 19.5003 21.8859 19.6456 21.9171 19.8468C21.9805 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9217 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5ZM2.55923 18.9383C4.15354 16.5446 6.66937 15 9.5 15C12.3306 15 14.8465 16.5446 16.4408 18.9383C16.79 19.4628 16.9647 19.725 16.9446 20.0599C16.9289 20.3207 16.758 20.64 16.5496 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82236C3.08617 21 2.71808 21 2.45044 20.7976C2.24205 20.64 2.07109 20.3207 2.05543 20.0599C2.03533 19.725 2.20996 19.4628 2.55923 18.9383Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const User02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M12 15C8.82993 15 6.0108 16.5306 4.216 18.906C3.82971 19.4172 3.63656 19.6728 3.64288 20.0183C3.64776 20.2852 3.81536 20.6219 4.02537 20.7867C4.29719 21 4.67387 21 5.42724 21H18.5728C19.3261 21 19.7028 21 19.9746 20.7867C20.1846 20.6219 20.3522 20.2852 20.3571 20.0183C20.3634 19.6728 20.1703 19.4172 19.784 18.906C17.9892 16.5306 15.1701 15 12 15Z"
      className="fill-none stroke-current"
    />
    <path
      d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const User03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UsersLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 11C11.7091 11 13.5 9.20914 13.5 7C13.5 4.79086 11.7091 3 9.5 3C7.29086 3 5.5 4.79086 5.5 7C5.5 9.20914 7.29086 11 9.5 11Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M19 21L16 18M16 18L19 15M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UserPlus01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M10 12C12.4853 12 14.5 9.98528 14.5 7.5C14.5 5.01472 12.4853 3 10 3C7.51472 3 5.5 5.01472 5.5 7.5C5.5 9.98528 7.51472 12 10 12Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UserPlus02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 11C10.933 11 12.5 9.433 12.5 7.5C12.5 5.567 10.933 4 9 4C7.067 4 5.5 5.567 5.5 7.5C5.5 9.433 7.067 11 9 11Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M19 10V4M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const SadFace = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Users01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 11C11.7091 11 13.5 9.20914 13.5 7C13.5 4.79086 11.7091 3 9.5 3C7.29086 3 5.5 4.79086 5.5 7C5.5 9.20914 7.29086 11 9.5 11Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UserRight01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" aria-label="follow" {...props}>
    <path
      d="M10 12C12.4853 12 14.5 9.98528 14.5 7.5C14.5 5.01472 12.4853 3 10 3C7.51472 3 5.5 5.01472 5.5 7.5C5.5 9.98528 7.51472 12 10 12Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M19 21L22 18M22 18L19 15M22 18H16M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UsersPlus = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 11C11.7091 11 13.5 9.20914 13.5 7C13.5 4.79086 11.7091 3 9.5 3C7.29086 3 5.5 4.79086 5.5 7C5.5 9.20914 7.29086 11 9.5 11Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UserLeft01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M10 12C12.4853 12 14.5 9.98528 14.5 7.5C14.5 5.01472 12.4853 3 10 3C7.51472 3 5.5 5.01472 5.5 7.5C5.5 9.98528 7.51472 12 10 12Z"
      className="opacity-12 fill-current"
    />
    <path
      d="M19 21L16 18M16 18L19 15M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);
